import { Controller } from '@hotwired/stimulus'

const CRITERION_VALUE = /\[territory_criteria_attributes\]\[[^\]]+\]\[value\]$/
const LOCATION_VALUE  = /\[territory_locations_attributes\]\[[^\]]+\]\[(country|state|county|city|zip)\]$/

// LRPO-1626 — keep group_index dense.
//
// ★ Groups are OR'd server-side BY INDEX. A gap left by an emptied group means
// the fold reads a rule the user never wrote — and the save succeeds, so nothing
// surfaces it. Compaction is the only thing preventing that.
//
// ★ There is no submit event to hang this off. The autosave reads the DOM with
// `new FormData(form)` and never submits, and `form.submit()` does not dispatch
// `submit` either. So the DOM is kept correct continuously instead.
export default class extends Controller {
  connect () {
    this.compact()
    this.observer = new MutationObserver(() => this.scheduleCompact())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect () {
    if (this.observer) this.observer.disconnect()
    clearTimeout(this.compactTimer)
  }

  // Coalesce bursts — adding a criterion touches several nodes at once — and
  // avoid re-entering the observer from our own writes.
  scheduleCompact () {
    clearTimeout(this.compactTimer)
    this.compactTimer = setTimeout(() => this.compact(), 0)
  }

  compact () {
    let next = 0

    this.element.querySelectorAll('[data-group-uid]').forEach(group => {
      const inputs = Array.from(group.querySelectorAll('input[name]'))
      const populated = inputs.some(input => {
        const name = input.getAttribute('name') || ''
        if (!CRITERION_VALUE.test(name) && !LOCATION_VALUE.test(name)) return false
        return String(input.value || '').trim() !== ''
      })

      if (!populated) return

      const index = String(next)
      next += 1

      inputs.forEach(input => {
        if (!(input.getAttribute('name') || '').endsWith('[group_index]')) return
        // Set BOTH, so the attribute and the property agree — FormData reads the
        // property, and anything re-serialising the markup reads the attribute.
        input.value = index
        input.setAttribute('value', index)
      })
    })
  }
}
